import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClient, QueryClientProvider } from 'react-query';

import { arquitecturaTheme } from './styles/theme';
import { AppMetaProvider } from './contexts/AppMetaContext';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout/Layout';
import Dashboard from './components/Dashboard/Dashboard';
import Conversations from './components/Conversations/Conversations';
import Projects from './components/Projects/Projects';
import VectorStorePage from './components/Projects/VectorStorePage';
import Analytics from './components/Analytics/Analytics';
import Scheduling from './components/Scheduling/Scheduling';
import AgentConfig from './components/AgentConfig/AgentConfig';
import Login from './components/Auth/Login';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import Users from './components/Users/Users';
import Clients from './components/Clients/Clients';
import InitiateCampaign from './components/Campaigns/InitiateCampaign';
import CampaignHistory from './components/Campaigns/CampaignHistory';
import CampaignCostReports from './components/Campaigns/CampaignCostReports';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={arquitecturaTheme}>
        <CssBaseline />
        <AuthProvider>
          <AppMetaProvider>
            <Router>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<Layout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="dashboard" element={<Dashboard />} />
                <Route 
                  path="conversations" 
                  element={
                    <ProtectedRoute requiredPermission="view_conversations">
                      <Conversations />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="projects" 
                  element={
                    <ProtectedRoute requiredPermission="manage_projects">
                      <Projects />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="projects/vector-store" 
                  element={
                    <ProtectedRoute requiredPermission="manage_projects">
                      <VectorStorePage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="analytics" 
                  element={
                    <ProtectedRoute requiredPermission="view_analytics">
                      <Analytics />
                    </ProtectedRoute>
                  }
                />
                <Route 
                  path="scheduling" 
                  element={
                    <ProtectedRoute requiredPermission="manage_scheduling">
                      <Scheduling />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="agent-config" 
                  element={
                    <ProtectedRoute requiredPermission="configure_agent">
                      <AgentConfig />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="users" 
                  element={
                    <ProtectedRoute requiredPermission="manage_users">
                      <Users />
                    </ProtectedRoute>
                  } 
                />
                <Route
                  path="clients"
                  element={
                    <ProtectedRoute requiredPermission="manage_contacts">
                      <Clients />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="campaigns/initiate"
                  element={
                    <ProtectedRoute requiredPermission="manage_users">
                      <InitiateCampaign />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="campaigns/history"
                  element={
                    <ProtectedRoute requiredPermission="manage_users">
                      <CampaignHistory />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="campaigns/cost-reports"
                  element={
                    <ProtectedRoute requiredPermission="export_campaign_cost_reports">
                      <CampaignCostReports />
                    </ProtectedRoute>
                  }
                />
                </Route>
              </Routes>
            </Router>
          </AppMetaProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
